import _extends from "@babel/runtime/helpers/extends";
import { Box, Card, SkeletonGroup, SkeletonRectangle, Text } from '@wix/design-system';
import React, { useCallback } from 'react';
import { wdsThemeColors } from '../../../../utils/wds-theme-colors';
import { CollapseListItem } from '../collapse-list-item';
import { StickyHeaderRoundedCorners } from './sticky-header-rounded-corners';
const cardBorderColorVar = '--collapse-list-card-border-color';
export const CardListItem = /*#__PURE__*/React.memo(_ref => {
  let {
    title,
    subtitle,
    children,
    showShadow = false,
    flatCardSurface = false,
    isLoading,
    showTitleWhenLoading,
    disabled,
    stickyHeader = false,
    headerPadding = 'medium',
    ...rest
  } = _ref;
  const CardWrapper = useCallback(_ref2 => {
    let {
      children: cardChildren
    } = _ref2;
    const cardContent = /*#__PURE__*/React.createElement(Box, _extends({
      display: "block"
    }, stickyHeader ? {
      overflow: 'visible'
    } : {
      borderRadius: '8px',
      overflow: 'hidden',
      style: {
        border: `1px solid var(${cardBorderColorVar})`,
        [cardBorderColorVar]: wdsThemeColors.borderDarkSecondary
      }
    }), cardChildren);
    return /*#__PURE__*/React.createElement(Box, {
      display: "block",
      position: "relative"
    }, flatCardSurface && stickyHeader ? cardContent : /*#__PURE__*/React.createElement(Card, {
      showShadow: showShadow
    }, cardContent), stickyHeader && /*#__PURE__*/React.createElement(StickyHeaderRoundedCorners, null));
  }, [flatCardSurface, showShadow, stickyHeader]);
  const renderTitle = useCallback(() => {
    if (isLoading && !showTitleWhenLoading) {
      return /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
        height: "18px",
        width: "86px"
      }));
    }
    return typeof title === 'string' ? /*#__PURE__*/React.createElement(Text, {
      ellipsis: true,
      size: "small",
      weight: "bold"
    }, title) : title;
  }, [isLoading, showTitleWhenLoading, title]);
  const renderSubtitle = useCallback(() => {
    if (isLoading && subtitle && !showTitleWhenLoading) {
      return /*#__PURE__*/React.createElement(Box, {
        paddingTop: "SP1"
      }, /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
        height: "4px",
        width: "102px"
      })));
    }
    return typeof subtitle === 'string' ? /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin"
    }, subtitle) : subtitle;
  }, [isLoading, showTitleWhenLoading, subtitle]);
  return /*#__PURE__*/React.createElement(CollapseListItem, _extends({
    disabled: disabled,
    headerPadding: headerPadding,
    showStickyBorder: true,
    stickyHeader: stickyHeader,
    subtitle: renderSubtitle(),
    title: renderTitle(),
    wrapper: CardWrapper
  }, rest), children);
});
//# sourceMappingURL=card-collapse-list-item.js.map